<template>
  <v-modal
    v-if="show"
    :show="show"
    @update:show="$emit('update:show', $event)"
    :isTableModal="true"
  >
    <h4 slot="header" class="title title-up">
      Couponeinlösungen (ID: {{ id }})
    </h4>
    <redeemed-coupon-customers-table :id="id"></redeemed-coupon-customers-table>
  </v-modal>
</template>

<script lang="babel">
import RedeemedCouponCustomersTable from "@/components/tables/RedeemedCouponCustomersTable";
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    RedeemedCouponCustomersTable,
    'v-modal': Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  }
};
</script>
